import type { NetworkFields } from '@tribeplatform/gql-client/graphql'
import type {
  Network,
  MutationUpdateMemberSchemaFieldArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getAuthTokenKey } from '../../utils/keys/authToken.keys.js'
import { getNetworkKey } from '../../utils/keys/network.key.js'

export const useUpdateMemberSchemaField = (options?: {
  fields?: NetworkFields
  useMutationOptions?: UseMutationOptions<
    Network,
    Error,
    MutationUpdateMemberSchemaFieldArgs
  >
}) => {
  const { useMutationOptions, fields = 'default' } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()
  const networkKey = getNetworkKey()
  const authTokenKey = getAuthTokenKey()

  return useMutation<Network, Error, MutationUpdateMemberSchemaFieldArgs>(
    input => client.network.updateMemberSchemaField(input, fields),
    {
      ...useMutationOptions,
      ...{
        onSettled: () => {
          queryClient.invalidateQueries(networkKey)
          queryClient.invalidateQueries(authTokenKey)
        },
      },
    },
  )
}
